module.exports = "/fonts/line-awesome.woff?8b1290595e57e1d49d95ff3fa1129ecc";